export default __webpack_public_path__ + "static/flipxyz-7366a8c0ac150c862efe1cb25f8bd98d.jpeg";